import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, ScreenClassRender } from 'react-grid-system';
import { getLocalizedText } from '@vp-dst/localization-util';
import socialMediaProducts from 'data/socialMediaProducts.json';

import {
  fireReadOnlyBriefPageHit,
  fireROBriefBackButtonClicked,
} from 'utils/Tracking';


import {
  setSelectedProduct,
  toggleMultiselectedProduct,
  setSelectedProductError,
  setSelectedProductConfigurations,
  setDocumentPagePreviewModalVisible,
  setDocumentPagePreviewModalDocumentPage,
} from 'redux/actionCreators';
import { defaultTextStyle, colors } from 'settings/theme';
import DSBriefModel from 'models/DSBriefModel';
import QueryStringUtil from 'utils/QueryStringUtil';

import ProductSelector from 'components/ProductSelector';
import DropdownMultiProductSelector from 'components/DropdownMultiProductSelector';
import SocialMediaInfoPanel from 'components/SocialMediaInfoPanel';
import BriefDetail from 'components/BriefDetail';
import Modal from 'components/vistaprintUILibrary/Modal';
import Button from 'components/vistaprintUILibrary/Button';
import Loader from 'components/vistaprintUILibrary/Loader';
import DocumentPageThumbnail from 'components/vistaprintUILibrary/DocumentPageThumbnail';

class ReadOnlyBrief extends React.Component {
  constructor(props) {
    super(props);

    this.productSectionRef = React.createRef();
    this.noteSectionRef = React.createRef();
    this.documentPagePreviewOnClick = this.documentPagePreviewOnClick.bind(this);
    this.documentPagePreviewModalOnClose = this.documentPagePreviewModalOnClose.bind(this);
    this.backOnClick = this.backOnClick.bind(this);
  }

  componentDidMount() {
    setTimeout(fireReadOnlyBriefPageHit, 1000);

    if (window.startMouseFlow) {
      window.startMouseFlow();
    }

    // if we have an alt doc id, populate the product, but overwrite the priceMultiplier and priceHTML such that the price is $5.00
    if (DSBriefModel.altDocId) {
      this.props.setSelectedProduct({
        ...DSBriefModel.preSelectedProduct,
        priceMultiplier: 1,
        priceHTML: DSBriefModel.localizedBasePriceHTML,
      });
    } else if (DSBriefModel.preSelectedProduct) {
      this.props.setSelectedProduct(DSBriefModel.preSelectedProduct);
    }

    if (DSBriefModel.preSelectedProductConfig.length > 0) {
      this.props.setSelectedProductConfigurations(DSBriefModel.preSelectedProductConfig, DSBriefModel.preSelectedProductPfid);
    }
  }

  selectedProductOnChange(selectedProduct) {
    const {
      setSelectedProduct,
    } = this.props;

    setSelectedProduct(selectedProduct);
  }


  documentPagePreviewOnClick({ altDocId, pageNumber }) {
    const {
      setDocumentPagePreviewModalVisible,
      setDocumentPagePreviewModalDocumentPage,
    } = this.props;

    setDocumentPagePreviewModalDocumentPage({ altDocId, pageNumber });
    setDocumentPagePreviewModalVisible(true);
  }

  backOnClick() {
    fireROBriefBackButtonClicked();

    if (window.tagMouseFlow) {
      window.tagMouseFlow('BackToDifyDashboard');
    }

    this.props.history.goBack();
  }

  documentPagePreviewModalOnClose() {
    const {
      setDocumentPagePreviewModalVisible,
    } = this.props;

    setDocumentPagePreviewModalVisible(false);
  }

  render() {
    const {
      selectedProduct,
      multiselectedProducts,
      selectedProductError,
      selectedProductConfigurations,
      noteError,
      noteErrorsSuppressed,
      documentPagePreviewModalVisible,
      documentPagePreviewModalDocumentPage,
      uploads,
      uploadRefs,
      note,
    } = this.props;

    const altDocId = DSBriefModel.altDocId;
    const numPages = DSBriefModel.templatesNum;

    return (
      <ScreenClassRender
        render={screenClass => {
          const containerRightLeftPadding = {
            'xs': 20,
            'sm': 40,
            'md': 40,
            'lg': 40,
            'xl': 80,
          };

          const containerShadow = '0 4px 5px 0 rgba(0,0,0,0.15)';
          const containerBorderRadius = '10px';
          const containerPadding = `30px ${containerRightLeftPadding[screenClass]}px`;
          const isSocialMediaDesign = QueryStringUtil.getValueByKey("smd") || (DSBriefModel.preSelectedProduct && DSBriefModel.preSelectedProduct.pfid === "DST-SMD");

          //SMD-TODO:  This is some hardcoded nonsense to support the fact that the french social media promotion email went out with an incorrect product name.  We should clean this up once we're pretty sure
          //no one will be clicking that link anymore.
          let fakeFrenchPreselectedSocialMediaProduct = {};
          Object.assign(fakeFrenchPreselectedSocialMediaProduct, DSBriefModel.preSelectedProduct);
          if (fakeFrenchPreselectedSocialMediaProduct) {
            fakeFrenchPreselectedSocialMediaProduct.name = "Visuels Pour Réseaux Sociaux";
          }
          const shouldUseFakeFrenchPreselectedProduct = (DSBriefModel.preSelectedProduct && DSBriefModel.preSelectedProduct.name === "SocialMediaDesign" && window.location.origin.split('.').pop().toLowerCase() === "fr"); //Trying to specifically target people who got the french social media email, and No One Else

          return (
            <Container fluid xs sm md>
              {!(DSBriefModel.templates || DSBriefModel.altDocId) && // if we have an alt-doc-id, we don't need to ask for which product
                <Row>
                  <Col xs={12}>
                    <div
                      ref={this.productSectionRef}
                      style={{
                        width: '100%',
                        borderRadius: containerBorderRadius,
                        paddingTop: 20,
                        paddingBottom: 20,
                        marginBottom: 40,

                        background: `linear-gradient(132deg, ${colors.blueMid}, ${colors.blueDark})`,
                        boxShadow: containerShadow,

                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          ...defaultTextStyle,
                          color: 'white',
                          fontSize: '2em',
                          fontWeight: 'bold',
                          textAlign: 'center',

                          marginBottom: 15,
                        }}
                      >
                        {getLocalizedText('hi-what-do-you-need-designed')}

                      </div>
                      <ProductSelector
                        productGroups={DSBriefModel.productsByCategory}
                        selectedProductOnChange={this.selectedProductOnChange}
                        selectedProduct={selectedProduct}
                        preSelectedProduct={shouldUseFakeFrenchPreselectedProduct ? fakeFrenchPreselectedSocialMediaProduct : DSBriefModel.preSelectedProduct}  //SMD-TODO:  When the above hardcoded fake preselected product stuff is cleaned up, this needs to just be preSelectedProduct={DSBriefModel.preSelectedProduct}
                        error={selectedProductError}
                        disabled={DSBriefModel.isEditFromCart || isSocialMediaDesign}
                      />
                    </div>
                  </Col>
                </Row>
              }
              <Row>
                <Col
                  xs={12}
                  style={{
                    overflow: 'visible', // allow shadow to spread beyond this container
                    marginBottom: 40,
                  }}
                >
                  <div
                    ref={this.noteSectionRef}
                    style={{
                      boxShadow: containerShadow,
                      borderRadius: containerBorderRadius,
                      padding: containerPadding,
                      backgroundColor: 'white',
                    }}
                  >

                      {isSocialMediaDesign &&
                      <div>
                        <SocialMediaInfoPanel/>
                    
                        <DropdownMultiProductSelector
                            productGroups={socialMediaProducts}
                            multiselectedProducts={multiselectedProducts}
                            preSelectedProduct={DSBriefModel.preSelectedProduct}
                            error={selectedProductError}
                            isReadOnly={DSBriefModel.isReadOnly}
                            key="multiselector"
                        />
                      </div>
                    }

                    <BriefDetail
                      altDocId={altDocId}
                      numPages={numPages}
                      note={note}
                      noteOnChange={this.noteOnChange}
                      noteErrorMessage={noteErrorsSuppressed ? null : noteError}
                      documentPagePreviewOnClick={this.documentPagePreviewOnClick}
                      selectedProductConfigurations={selectedProductConfigurations}
                      removeProductConfigurationOnClick={this.removeProductConfigurationOnClick}
                      isReadOnly={DSBriefModel.isReadOnly}
                      uploads={uploads}
                      uploadRefs={uploadRefs}
                    />
                    <div
                      style={{
                        marginTop: 40,
                        textAlign: 'center',
                      }}
                    >

                      <Button
                        style={{
                          width: '100%',
                          maxWidth: 400,
                        }}
                        type="primary"
                        text={getLocalizedText('back')}
                        large={true}
                        onClick={this.backOnClick}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Modal
                open={documentPagePreviewModalVisible}
                buttons={
                  <Button
                    type="secondary"
                    text={getLocalizedText('close')}
                    onClick={this.documentPagePreviewModalOnClose}
                  />
                }
                onClose={this.documentPagePreviewModalOnClose}
              >
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 20,
                  }}
                >
                  {documentPagePreviewModalDocumentPage === null &&
                    <Loader text={getLocalizedText('loading-preview')} />
                  }
                  {documentPagePreviewModalDocumentPage !== null &&
                    <DocumentPageThumbnail
                      altDocId={documentPagePreviewModalDocumentPage.altDocId}
                      pageNumber={documentPagePreviewModalDocumentPage.pageNumber}
                      templateId={documentPagePreviewModalDocumentPage.templateId}
                      height="calc(100% - 60px)" // 100% of the container - 60px for the close button
                      width="100%"
                      maxHeight="calc(60vh - 60px - 95px)" // height of the modal - 60px for the close button - 95px for the modal heading and padding
                      maxWidth="100%"
                      imageWidthPixels={400}
                      imageHeightPixels={400}
                      shadow={false}
                      showBorder={true}
                      zoomable={true}
                      zoomFactor={2}
                    />
                  }
                </div>
              </Modal>
            </Container>
          );
        }}
      />
    );
  }
};

const mapStateToProps = state => {
  return {
    selectedProduct: state.selectedProduct,
    multiselectedProducts: state.multiselectedProducts,
    selectedProductError: state.selectedProductError,
    selectedProductConfigurations: state.selectedProduct ? (state.selectedProductConfigurationsMap.get(state.selectedProduct.pfid) || []) : [],
    note: state.note,
    uploads: state.uploads,
    uploadRefs: state.uploadRefs,
    documentPagePreviewModalVisible: state.documentPagePreviewModalVisible,
    documentPagePreviewModalDocumentPage: state.documentPagePreviewModalDocumentPage,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleMultiselectedProduct: selectedProduct => dispatch(toggleMultiselectedProduct(selectedProduct)),
    setSelectedProduct: selectedProduct => dispatch(setSelectedProduct(selectedProduct)),
    setSelectedProductError: selectedProductError => dispatch(setSelectedProductError(selectedProductError)),
    setSelectedProductConfigurations: (selectedProductConfigurations, pfid) => dispatch(setSelectedProductConfigurations(selectedProductConfigurations, pfid)),
    setDocumentPagePreviewModalVisible: documentPagePreviewModalVisible => dispatch(setDocumentPagePreviewModalVisible(documentPagePreviewModalVisible)),
    setDocumentPagePreviewModalDocumentPage: documentPagePreviewModalDocumentPage => dispatch(setDocumentPagePreviewModalDocumentPage(documentPagePreviewModalDocumentPage)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReadOnlyBrief);



// WEBPACK FOOTER //
// ./src/pages/ReadOnlyBrief.js